import { useRouteError, Link } from 'react-router';

interface RouteError {
  statusText?: string;
  message?: string;
}

export default function ErrorPage() {
  const error = useRouteError() as RouteError;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg w-full">
        <div className="text-center">
          {/* Error Icon */}
          <div className="mx-auto h-24 w-24 bg-red-100 rounded-full flex items-center justify-center mb-8">
            <svg
              className="h-12 w-12 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          {/* Error Code */}
          <h1 className="text-8xl sm:text-9xl font-extrabold text-slate-900 mb-4 tracking-tight">
            404
          </h1>

          {/* Error Title */}
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-4">
            Page Not Found
          </h2>

          {/* Error Message */}
          <p className="text-base sm:text-lg text-slate-600 mb-8 leading-relaxed max-w-md mx-auto">
            {error?.statusText ||
              error?.message ||
              "Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL."}
          </p>

          {/* Action Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              Go to Home Page
            </Link>
          </div>

          {/* Additional Help Text */}
          <p className="mt-8 text-sm text-slate-500">
            Need help? Contact our support team or try refreshing the page.
          </p>
        </div>
      </div>
    </div>
  );
}
